import { render, staticRenderFns } from "./UploadKey.vue?vue&type=template&id=4ba523ba&scoped=true&"
import script from "./UploadKey.vue?vue&type=script&lang=js&"
export * from "./UploadKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba523ba",
  null
  
)

export default component.exports